module.exports = __webpack_public_path__ + "img/as-om.071c4139.jpg";